// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./wp-content/plugins/instaberg/src/templates/_demo/tpl.view.scss
// module id = 155
// module chunks = 0 1